import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCapRound = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 9c0-2.7 2.3-5 5.2-5H15v10H8.1C5.3 14 3 11.7 3 9zm11 1V8h-4c-.3-.9-1.3-1.5-2.4-1.5C6.1 6.5 5 7.6 5 9s1.2 2.5 2.6 2.5c1.1 0 2-.5 2.4-1.5h4z"
	})
});
export default SvgCapRound;
